// Polyfills for older browsers (Safari / iOS < 18) that pdfjs-dist v5 relies on.
// Each one is installed ONLY when the browser lacks the API, so modern browsers
// run exactly the same native code as before. Must be the first import in main.tsx.
// Ticket HD-6743C045: "URL.parse is not a function" crashed every PDF tab on iOS 17.

type UrlCtor = typeof URL & { parse?: (url: string | URL, base?: string | URL) => URL | null };
type PromiseCtor = PromiseConstructor & { withResolvers?: () => unknown };

const urlCtor = URL as UrlCtor;
const promiseCtor = Promise as PromiseCtor;

// Detected before installing anything below. The pdf.js worker runs in its own
// global scope where these main-thread polyfills don't exist, so such browsers
// must also load pdf.js's legacy worker build (see pdf-annotator).
export const needsLegacyPdfWorker =
  typeof urlCtor.parse !== 'function' || typeof promiseCtor.withResolvers !== 'function';

if (typeof urlCtor.parse !== 'function') {
  urlCtor.parse = (url, base) => {
    try {
      return new URL(url, base);
    } catch {
      return null;
    }
  };
}

if (typeof promiseCtor.withResolvers !== 'function') {
  promiseCtor.withResolvers = function withResolvers<T>(this: PromiseConstructor) {
    let resolve!: (value: T | PromiseLike<T>) => void;
    let reject!: (reason?: unknown) => void;
    const promise = new this<T>((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}
